import { useArticleGroupListQuery } from "entities/manageArticles/queries/useArticleGroupListQuery";
import {
  ArticleBrandId,
  ArticleCategory,
  ArticleGroupIds,
} from "entities/manageArticles/types";
import ManageArticlesLayout from "modules/manageArticles/components/ManageArticlesLayout";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import TableWithPagination from "shared/components/TableWithPagination";
import { MANAGE_ARTICLE_DETAILS_PATH } from "shared/routes/paths";
import ArticleGroupHeader from "./components/ArticleGroupHeader";
import DeletingArticleModal from "./components/DeletingArticleModal";
import { ArticleGroupPageProvider, useArticleGroupPage } from "./context";
import { getArticlesGroupColumns } from "./helpers";

const ArticleGroupPageContainer = () => {
  return (
    <ArticleGroupPageProvider>
      <ArticleGroupPage />
    </ArticleGroupPageProvider>
  );
};

const ArticleGroupPage = () => {
  const { brandId, categoryId, groupId } = useParams();
  const {
    articlePageTitle,
    isOpenDeletingArticleModal,
    closeDeletingArticleModal,
  } = useArticleGroupPage();
  const navigate = useNavigate();

  const { data: fileListByGroupId = [], isLoading } = useArticleGroupListQuery({
    brandId: brandId as ArticleBrandId,
    categoryId: categoryId as ArticleCategory,
    groupId: groupId as ArticleGroupIds,
  });

  const columns = getArticlesGroupColumns();

  return (
    <>
      <ManageArticlesLayout>
        <FlexColumn gap={"1.5rem"} py={"1rem"}>
          <ArticleGroupHeader title={articlePageTitle} />
          <TableWithPagination
            heightTable="100%"
            data={fileListByGroupId}
            columns={columns}
            loading={isLoading}
            emptyStateMessage="There are no files here yet."
            hideFooter
            onRowClick={(params) => {
              navigate(
                generatePath(MANAGE_ARTICLE_DETAILS_PATH, {
                  brandId: brandId as ArticleBrandId,
                  categoryId: categoryId as ArticleCategory,
                  groupId: groupId as ArticleGroupIds,
                  id: params.row.id,
                }),
              );
            }}
          />
        </FlexColumn>
      </ManageArticlesLayout>
      <DeletingArticleModal
        open={isOpenDeletingArticleModal}
        onClose={closeDeletingArticleModal}
      />
    </>
  );
};

export default ArticleGroupPageContainer;
